/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Selected_ListInputs */



/**
* | output |
* | --- |
* | "Remove Selected List" |
*
* @param {Remove_Selected_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_selected_list = /** @type {((inputs?: Remove_Selected_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Selected_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la liste sélectionnée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Liste entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi elenco selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить выбранный список")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar lista seleccionada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除已选列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したリストを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित सूची हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover lista selecionada")
	return /** @type {LocalizedString} */ ("Remove Selected List")
});